import { useUserData } from '@/composables/useUserData';
import { isJWTExpiringSoon, isJWTExpired } from '~/utils/jwt';

export default defineNuxtPlugin(async () => {
  // Skip auth in Storybook (no backend available)
  if (typeof window !== 'undefined' && window.__STORYBOOK_PREVIEW__) {
    return;
  }

  // Get the current user session
  const { session, fetch, clear } = useUserSession();
  const { clearUserData, fetchUserDetails } = useUserData();
  const { $localeRootPath } = useNuxtApp();
  const router = useRouter();
  const route = useRoute();

  // Function to handle logout
  const handleLogout = async () => {
    // Clear user data
    clearUserData();

    // Clear session
    await clear();

    // only redirect if the user is on account pages
    if (route.path.includes('/account/')) {
      // Store the current path for redirect after login
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('fromUri', window.location.origin + router.currentRoute.value.fullPath);
      }

      window.location.replace($localeRootPath('/account/login'));
    }
  };

  // If we have a session but it's approaching expiration, refresh it
  if (session.value?.idToken) {
    try {
      await fetchUserDetails();
    } catch (error) {
      console.error('Failed to fetch user details:', error);
    }

    if (isJWTExpiringSoon(session.value.idToken, 5)) {
      try {
        // Call our refresh endpoint
        await $fetch('/api/auth/refresh', { method: 'POST' });
        // Update the session
        await fetch();
      } catch (error) {
        console.error('Failed to refresh token:', error);

        // If refresh fails, log the user out and optionally redirect to login page
        await handleLogout();
      }
    }

    // Check if token is already expired
    if (isJWTExpired(session.value.idToken)) {
      console.warn('Token has expired. Redirecting to login page...');
      await handleLogout();
    }
  }
});
